import React from 'react';
import { isEmpty } from '~/utils';

interface ImportMemberTipProps {
    /** 导入提示项 */
    tips: React.ReactNode[];
}

/**
 * 成员导入模板提示
 */
const ImportMemberTip: React.FC<ImportMemberTipProps> = (props) => {
    const { tips } = props;

    if (isEmpty(tips)) {
        return null;
    }

    return (
        <div className="fx-import-member-tip">
            {tips.map((tip, index) => (
                <li className="tip-item" key={index}>
                    {tip}
                </li>
            ))}
        </div>
    );
};

export default ImportMemberTip;
